import {Gem} from 'lucide-react'

function Footer() {
  return (
    <footer className="bg-gray-900 text-gray-300 mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-3 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <Gem className="w-6 h-6 text-emerald-400" />
              <span className="text-xl font-bold text-white">Gemstone Calculator</span>
            </div>
            <p className="text-sm text-gray-400">
              Professional gemstone weight and value estimation tool for jewelers, gemologists, and enthusiasts worldwide.
            </p>
          </div>
          
          <div>
            <h3 className="text-white font-semibold mb-4">Calculator Tools</h3>
            <ul className="space-y-2 text-sm">
              <li><a href="/emerald-calculator" className="hover:text-emerald-400 transition-colors">Emerald Weight Calculator</a></li>
              <li><a href="/sapphire-calculator" className="hover:text-emerald-400 transition-colors">Sapphire Price Calculator</a></li>
              <li><a href="/amethyst-calculator" className="hover:text-emerald-400 transition-colors">Amethyst Value Calculator</a></li>
              <li><a href="/opal-calculator" className="hover:text-emerald-400 transition-colors">Opal Carat Calculator</a></li>
              <li><a href="/birthstone-calculator" className="hover:text-emerald-400 transition-colors">Birthstone Finder</a></li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-white font-semibold mb-4">About</h3>
            <p className="text-sm text-gray-400">
              Our calculator uses scientific specific gravity measurements and current market data to provide accurate gemstone weight and value estimations.
            </p>
          </div>
        </div>
        
        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-sm text-gray-500">
          <p>© 2024 Gemstone Calculator. All rights reserved. | Professional gem analysis tools.</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
